<template>
	<div id="upsell-page">
		<section class="category_top_banner s_cat_in_top_banner cover" v-lazy:background-image="wpData.general.hero">
			<div class="container">
				<h2 class="title">{{ wpData.general.title }}</h2>
				<div class="text">{{ wpData.general.subtitle }}</div>
			</div>
			<div class="bn_corner desktop-only"></div>
			<div class="bn_corner mobile-only"></div>
		</section>

		<div class="inner_page">
			<div class="container logged-out" v-if="!isUserLoggedIn">
				<h3>{{ wpData.not_logged_in.title }}</h3>
				<p class="ws-bs" v-html="wpData.not_logged_in.text">
					Lorem ipsum dolor, sit amet consectetur adipisicing elit. Laudantium facilis id tempora architecto
					amet obcaecati, non aspernatur nam impedit illo similique cum adipisci ratione nesciunt consequuntur
					delectus at tempore repellat.
				</p>
				<button class="login-button" @click="$modal.show('login-modal')">
					{{ wpData.not_logged_in.login_text }}
					<ARROWLONG />
				</button>
			</div>

			<div class="container" v-if="isUserLoggedIn">
				<h3>{{ wpData.slider_1.title }}</h3>
				<Transition name="fade" mode="out-in">
					<SliderLoader v-if="loadingPersonalProducts" />
					<ProductSlider v-else :products="personalProducts" />
				</Transition>
			</div>

			<br /><br />

			<div class="container">
				<h3>{{ wpData.slider_2.title }}</h3>
				<Transition name="fade" mode="out-in">
					<SliderLoader v-if="loadingPopularProducts" />
					<ProductSlider v-else :products="popularProducts" />
				</Transition>
			</div>
		</div>


	</div>
</template>

<script>
	import { mapState } from "vuex";
	import ProductSlider from "../../components/UpsellPage/ProductSlider.vue";
	import SliderLoader from "../../components/UpsellPage/SliderLoader.vue";
	import ARROWLONG from "../../assets/img/arrow-long.svg";

	export default {
		name: "UpsellPage",
		data() {
			return {
				wpData: wpData.globalOptions.upsell_page,
				ajax_url: wpData.ajax_url,
				personalProducts: [],
				popularProducts: [],
				loadingPersonalProducts: true,
				loadingPopularProducts: true,
			};
		},
		metaInfo() {
			const { seo_title, seo_desc } = this.wpData.general;
			return {
				title: seo_title,
				meta: [
					{
						name: "description",
						content: seo_desc,
					},
				],
			};
		},
		methods: {
			getCartItems() {
				return this.$store.state.added.map((i) => i.id).join();
			},
			getPersonalRecommendations() {
				let endpoint = this.ajax_url;
				const args = {
					action: "cfp_ajax_get_products_by_user",
					user_id: this.$store.state.userLoggedInfo.id,
					num_of_orders: this.wpData.slider_1.num_of_orders_to_scan,
					num_of_products: this.wpData.slider_1.num_of_products_to_show,
					exclude_product_ids: this.getCartItems(),
					exclude_categories: this.wpData.slider_1.exclude_categories
						? this.wpData.slider_1.exclude_categories.join()
						: [],
				};
				const params = new URLSearchParams();
				Object.entries(args).forEach((param) => params.append(...param));
				endpoint = endpoint + "?" + params.toString();
				fetch(endpoint)
					.then((raw) => raw.json())
					.then((json) => {
						const filteredProducts = json.data.filter((product) => {
							if (this.includesProductID(this.popularProducts, product.id)) {
								return false;
							}
							return true;
						});
						this.personalProducts = filteredProducts;
						this.loadingPersonalProducts = false;
					});
			},
			getGeneralRecommendations() {
				let endpoint = this.ajax_url;
				const args = {
					action: "cfp_ajax_get_popular_products",
					num_of_orders: this.wpData.slider_2.num_of_orders_to_scan,
					num_of_products: this.wpData.slider_2.num_of_products_to_show,
					// exclude_product_ids: this.getCartItems(),
					exclude_product_ids: [],
					exclude_categories: this.wpData.slider_2.exclude_categories
						? this.wpData.slider_2.exclude_categories.join()
						: [],
					only_on_sale: this.wpData.slider_2.show_only_on_sale,
				};
				const params = new URLSearchParams();
				Object.entries(args).forEach((param) => params.append(...param));
				endpoint = endpoint + "?" + params.toString();
				fetch(endpoint)
					.then((raw) => raw.json())
					.then((json) => {
						const cartItems = this.$store.state.added;
						let filteredProducts = json.data.filter((product) => {
							if (this.includesProductID(this.personalProducts, product.id)) {
								return false;
							}
							if (this.includesProductID(cartItems, product.id)) {
								return false;
							}
							return true;
						});
						filteredProducts.splice(this.wpData.slider_2.num_of_products_to_show, 999);
						this.popularProducts = filteredProducts;
						this.loadingPopularProducts = false;
					});
			},
			includesProductID(productArray, productID) {
				const foundIndex = productArray.findIndex((item) => item.id === productID);
				if (foundIndex === -1) {
					return false;
				}
				return true;
			},
		},
		computed: {
			...mapState({ isUserLoggedIn: (state) => state.userLogged }),
		},
		watch: {
			isUserLoggedIn: function () {
				if (this.isUserLoggedIn) {
					this.getPersonalRecommendations();
				}
			},
		},
		created() {
			sessionStorage.setItem("upsellPageWasShown", Date.now());
			document.body.classList.remove("woocommerce-checkout", "woocommerce-page");
			setTimeout(() => {
				if (!this.isUserLoggedIn) {
					return false;
				}
				this.getPersonalRecommendations();
			}, 100);
			setTimeout(() => {
				this.getGeneralRecommendations();
			}, 600);
		},
		components: {
			ProductSlider,
			SliderLoader,
			ARROWLONG,
		},
	};
</script>

<style lang="sass" scoped="">

	#upsell-page
		background: #efede9

		.desktop-only
			display: block
		.mobile-only
			display: none
		.ws-bs
			white-space: break-spaces

	h3
		margin-bottom: 2rem

	#upsell-floater
		position: sticky
		bottom: 0
		left: 0
		width: 100%
		background: linear-gradient(0deg, rgba(#cbe5c2,1) 0%, rgba(255,255,255,0) 100%)
		padding: 2rem 3rem
		z-index: 2
		text-align: center

		button
			border-radius: 1rem
			box-shadow: 0 0.5rem 1.5rem 0 rgba(#000, 0.2)
			background: #213519
			color: #fff
			border: none
			padding: 1rem 2rem
			border-radius: 10rem
			white-space: nowrap
			overflow: hidden
			text-overflow: ellipsis
			max-width: 100%

			&:hover
				background-color: #1e824c
			&:active
				background-color: #229657


	.fade-enter-active, .fade-leave-active
		transition: opacity .3s
	.fade-enter, .fade-leave-to
		opacity: 0


	.container.logged-out
		margin-bottom: 1.5rem

		h3
			margin-bottom: 1rem

	.login-button
		background-color: #213519
		color: white
		border: none
		padding: 0.5rem 1.5rem
		border-radius: 5rem
		font-weight: bold
		margin: 1rem 0 0 0
		&:hover
			background-color: #1e824c
		&:active
			background-color: #229657

		svg
			fill: #fff
			margin-right: 0.35rem
			fill: #ffffff
			transform: translateY(1px)


	/* Mobile */
	@media only screen and (max-width: 800px)

		#upsell-page
			.desktop-only
				display: none
			.mobile-only
				display: block

		.category_top_banner
			height: auto
			padding-top: 2rem
			padding-bottom: 2rem
			.text
				display: block
				height: auto
</style>
